import styled from 'styled-components';

import Card from 'components/insights/layout/Card';
import { ScrollContainer } from 'components/shared/DataTable';

import { PROVIDER_PERFORMANCE_TABLE_PARAMS } from '../constants';
import useNetworkPerformanceAnalytics from '../query/useNetworkPerformanceAnalytics';

import ProviderPerformanceHeader from './ProviderPerformanceHeader';
import ProviderPerformanceTable from './ProviderPerformanceTable';

export default function ProviderPerformanceSection() {
  const { loading, rollups } = useNetworkPerformanceAnalytics(PROVIDER_PERFORMANCE_TABLE_PARAMS, {
    queryKey: 'networkPerformanceTable',
  });

  return (
    <SectionCard>
      <ProviderPerformanceHeader />
      <TableWrapper>
        <ProviderPerformanceTable loading={loading} rollups={rollups} />
      </TableWrapper>
    </SectionCard>
  );
}

const SectionCard = styled(Card)`
  padding: 0;
  display: flex;
  flex-direction: column;
  border-radius: 4px;
`;

const TableWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: 0 24px 24px;

  td:first-child:not(:last-child),
  th:first-child {
    border-right: 1px solid ${({ theme }) => theme.colors.black10};
  }

  @media (max-width: 800px) {
    padding: 0;

    ${ScrollContainer} {
      border-top-left-radius: 0;
      border-top-right-radius: 0;
      border-left: none;
      border-right: none;
      border-bottom: none;
    }
  }
`;
